import { apiFetch } from "@/lib/api";

export type AlternateOrderSource =
  | "manual"
  | "production_calendar"
  | "alternates_page"
  | "incoming_orders"
  | "edit_batch";

export interface AlternateOrderRecord {
  id: number;
  locationId: number;
  sku: string;
  quantity: number;
  quantityFulfilled: number;
  remainingToBuild: number;
  targetDate: string | null;
  requiresEncapsulation: boolean;
  status: "open" | "complete" | "cancelled";
  source: AlternateOrderSource;
  batchId: number | null;
  salesOrderId: number | null;
  notes: string | null;
}

export interface CreateAlternateOrderBody {
  sku: string;
  quantity: number;
  targetDate: string | null;
  requiresEncapsulation: boolean;
  source: AlternateOrderSource;
  batchId?: number | null;
  salesOrderId?: number | null;
  notes?: string | null;
}

export function createAlternateOrder(body: CreateAlternateOrderBody): Promise<AlternateOrderRecord> {
  return apiFetch<AlternateOrderRecord>("/api/manufacturing/alternate-orders", {
    method: "POST",
    body,
  });
}

export function fetchAlternateOrder(alternateOrderId: number): Promise<AlternateOrderRecord> {
  return apiFetch<AlternateOrderRecord>(`/api/manufacturing/alternate-orders/${alternateOrderId}`);
}

export interface OpenAlternateOrdersResponse {
  orders: AlternateOrderRecord[];
}

export const OPEN_ALTERNATE_ORDERS_QUERY_KEY = ["manufacturing", "alternate-orders", "open"] as const;

export function fetchOpenAlternateOrders(): Promise<OpenAlternateOrdersResponse> {
  return apiFetch<OpenAlternateOrdersResponse>("/api/manufacturing/alternate-orders/open");
}

export interface CancelAlternateOrderBody {
  confirmPartialFulfillment?: boolean;
}

export function cancelAlternateOrder(
  alternateOrderId: number,
  body: CancelAlternateOrderBody = {},
): Promise<AlternateOrderRecord> {
  return apiFetch<AlternateOrderRecord>(`/api/manufacturing/alternate-orders/${alternateOrderId}/cancel`, {
    method: "POST",
    body,
  });
}
